import { Check } from "lucide-react";
import { TRUST } from "../data/content";

export const TrustMarquee = () => {
  const items = [...TRUST, ...TRUST];
  return (
    <section data-testid="trust-bar" className="bg-[#2B2B30] py-5 overflow-hidden border-y border-white/5">
      <div className="marquee-track">
        {items.map((t, i) => (
          <div key={i} className="flex items-center gap-3 px-8 shrink-0">
            <Check className="w-4 h-4 text-[#D32F2F]" />
            <span className="font-display text-white/90 text-sm uppercase tracking-[0.12em] whitespace-nowrap">{t}</span>
          </div>
        ))}
      </div>
    </section>
  );
};
